module.exports = __webpack_public_path__ + "media/images/venu_fav-298d2c772780abf578792b6654c45a87.ico";